/**
*
* LoadLocalPlanErrorDialog
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Text from 'ui/Text';
import messages from './messages';
import { KompisPrompt } from '@inter-ikea-kompis/react-components';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

const LoadLocalPlanErrorDialog = ({ show, onDismiss, cwcalcReachedFromIpexGallery }) =>  {
  const { formatMessage } = useIntl();
  return (
    <KompisPrompt
    heading={formatMessage({
      id: messages.vpcErrorTitle.id, defaultMessage: messages.vpcErrorTitle.defaultMessage 
    }) + " " + formatMessage({
      id: messages.vpcErrorSubtitle.id, defaultMessage: messages.vpcErrorSubtitle.defaultMessage
    })}
    primaryButtonLabel={formatMessage({
      id: messages.dismiss.id, defaultMessage: messages.dismiss.defaultMessage
    })}
    onButtonClick={event => {
      onDismiss();
      if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
        // onContinueClick();
      } else {
        // onBackClick();
      }
    }}
    visible={show}
    theme={SkapaTheme}
    disableIframeSticky={cwcalcReachedFromIpexGallery}
    >
    <Text theme={SkapaTheme}>
      {formatMessage({
        id: messages.planNotFound.id, defaultMessage: messages.planNotFound.defaultMessage
      })}
    </Text>
  </KompisPrompt>)
}

LoadLocalPlanErrorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default LoadLocalPlanErrorDialog;
